import Vue from 'vue'
import App from './App.vue'
import router from './router'
window.$ = window.jQuery = require('jquery')
import 'bootstrap'
import { BootstrapVue,} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import firebase from 'firebase'
Vue.use(BootstrapVue)

const firebaseConfig = {
  apiKey: "AIzaSyC6YMxT2eLYCMXInQcN-l6RS_taNv2g1oc",
  authDomain: "melodyrecord9022.firebaseapp.com",
  projectId: "melodyrecord9022",
  storageBucket: "melodyrecord9022.appspot.com",
  messagingSenderId: "852995929790",
  appId: "1:852995929790:web:777976b65dc9ded56750ef"
};

firebase.initializeApp(firebaseConfig);





Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')



